export const WHATSAPP_NUMBER = "436766766999";
export const WHATSAPP_DISPLAY = "+43 676 6766999";

export const COMPANY = {
    name: "NA Performance",
    sub: "PerformanceOS",
    street: "Logistikstraße 7 / Halle D",
    zip_city: "2201 Hagenbrunn",
    city: "Hagenbrunn",
    country: "Österreich",
    email: "office@naperformance.at",
};

export function whatsappLink(text) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "")}`;
}

export const DEFAULT_WA_MESSAGE =
    "Hallo, ich interessiere mich für eine Fahrzeugoptimierung und hätte gerne ein Angebot.";

export function buildVehicleWaMessage({ vehicle, stage }) {
    const fzg = vehicle ? `${vehicle.marke || ""} ${vehicle.modell || ""}`.trim() : "";
    return (
        "Hallo,\n\n" +
        "ich habe eine Fahrzeuganalyse durchgeführt und interessiere mich für ein Angebot.\n\n" +
        (fzg ? `Fahrzeug:\n${fzg}\n\n` : "") +
        (stage ? `Empfohlene Optimierung:\n${stage}\n\n` : "") +
        "Bitte kontaktieren Sie mich."
    );
}

export const MEDIA = {
    hero: "https://static.prod-images.emergentagent.com/jobs/932028c4-f0e0-4ce3-a85f-60fadc40a9f5/images/9ffc8416f9663703c2ecfab27c99a4f68585ee8c3c73562def635b82083bbb1a.png",
    abstract:
        "https://static.prod-images.emergentagent.com/jobs/932028c4-f0e0-4ce3-a85f-60fadc40a9f5/images/9a43e41bc08555d977bd4adca13353fa8f80533c83833d2763faf7d67427bbd3.png",
    ocr: "https://static.prod-images.emergentagent.com/jobs/932028c4-f0e0-4ce3-a85f-60fadc40a9f5/images/1b1a5a62723747056ccc8836afac382ee7b3d7d58521face18f4dfa7eb1666c4.png",
    porsche:
        "https://images.unsplash.com/photo-1609903730357-fc7951f05910?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxwb3JzY2hlJTIwZGFyayUyMHN0dWRpbyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MDE3MzA4N3ww&ixlib=rb-4.1.0&q=85",
    porscheRear:
        "https://images.unsplash.com/photo-1695192193767-54887768f845?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxwb3JzY2hlJTIwZGFyayUyMHN0dWRpbyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MDE3MzA4N3ww&ixlib=rb-4.1.0&q=85",
    engine:
        "https://images.pexels.com/photos/11455717/pexels-photo-11455717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
